/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const useClientFields = (queryParams) => {
  return useQuery({
    queryKey: queryKeys.client.fields,
    queryFn: async () => {
      const response = await fetcher({ method: "GET", url: "/public/clients/fields" });
      return response.data;
    },
    ...queryParams,
  });
};
